import app from './index';

/**
 * The services tree is one level deep, so top services plus their children is the full list
 * (the server no longer sends it separately). Only id/title lookups and the length are read.
 */
function flattenServices(topServices) {
    const services = [];

    _.forEach(topServices, (service) => {
        services.push(_.omit(service, 'children'));

        _.forEach(_.get(service, 'children', []), (child) => {
            services.push(child);
        });
    });

    return services;
}

/**
 * Save pre-fetched cms data into $store before rendering page
 */
if (_.get(context, 'isCmsContent', false)) {
    app.$store.commit('setCmsContent', context.isCmsContent)
}

/**
 *  * Save pre-fetched user profile into $store before rendering profile (for SEO purposes)
 */
if (_.get(context, 'preFetchedUser', false)) {
    app.$store.commit('setPreFetchedUser', context.preFetchedUser)
}

if (_.get(context, 'isSeekingServicesProfile', false)) {
    app.$store.commit('setIsSeekingServicesProfile', context.isSeekingServicesProfile)
}

/**
 * Save search result users into $store before rendering search page (for SEO purposes)
 */
if (_.get(context, 'searchResponse', false)) {
    const searchResponse = context.searchResponse;

    if (_.get(searchResponse, 'noUsersFound', false)) {
        delete searchResponse.noUsersFound;
        app.$store.commit('setSearchResponse', {
            total: 0,
            users: searchResponse,
            request: _.get(context, 'searchRequest', {}),
        });
    } else {
        app.$store.commit('setSearchResponse', {
            total: _.get(searchResponse, 'total.value', 0),
            users: _.map(searchResponse.hits, '_source'),
            current_page: 1,
            last_page: _.get(searchResponse, 'last_page', 1),
            request: _.get(context, 'searchRequest', {}),
        });
    }
}

if (_.get(context, 'locationData', false)) {
    if (_.has(context, 'locationData.radius')) {
        app.$store.commit('setSearchRadius', `${_.get(context, 'locationData.radius', 20)}km`);
    }

    app.$store.commit('setLocation', context.locationData);
}

if (_.get(context, 'categoryData', false)) {
    app.$store.commit('setCategory', context.categoryData);
}

if (_.get(context, 'translate', false)) {
    app.$store.commit('setTranslate', context.translate);
}

if (_.get(context, 'regionData', false)) {
    app.$store.commit('setRegionData', context.regionData);
}

if (_.get(context, 'locale', false)) {
    app.$store.commit('setLocale', context.locale)
}

if (_.get(context, 'topServicesData', false)) {
    app.$store.commit('setTopServices', context.topServicesData);
    app.$store.commit('setAllServices', flattenServices(context.topServicesData));
}

if (_.get(context, 'homepageGirls', false)) {
    app.$store.commit('setHomeGirls', context.homepageGirls);
}

if (_.get(context, 'servicesData', false)) {
    app.$store.commit('setServices', context.servicesData);
}

if (_.get(context, 'featuresData', false)) {
    app.$store.commit('setFeatures', context.featuresData);
}

if (_.get(context, 'is404ViewData', false)) {
    app.$store.commit('setIs404View', true)
}

if (_.get(context, 'similarEscortsData', false)) {
    const similarEscorts = _.map(context.similarEscortsData.hits, '_source')
    app.$store.commit('setSimilarEscorts', similarEscorts);
}

if (_.get(context, 'currentUserData', false)) {
    app.$store.commit('setCurrentUser', context.currentUserData);
}

if (_.get(context, 'isManagerLoggedIn', false)) {
    app.$store.commit('setIsManagerLoggedInAsEscort', context.isManagerLoggedIn);
}

if (_.get(context, 'managerData', false)) {
    app.$store.commit('setManagerAsEscortData', context.managerData);
}

if (_.get(context, 'settings', false)) {
    app.$store.commit('setSettings', context.settings);
}

if (_.get(context, 'featureOptions', false)) {
    app.$store.commit('setFeatureOptions', context.featureOptions)
}

if (_.get(context, 'ranges', false)) {
    app.$store.commit('setRanges', context.ranges)
}

if (_.has(context, 'venue')) {
    app.$store.commit('setVenue', context.venue);
}

if (_.has(context, 'asia')) {
    app.$store.commit('setAsia', context.asia);
}

if (_.has(context, 'suggestedRedirectRegion')) {
    app.$store.commit('setSuggestedRedirectRegion', context.suggestedRedirectRegion);
}

if (_.has(context, 'countryNameShort')) {
    app.$store.commit('setCountryNameShort', context.countryNameShort);
}

if (_.has(context, 'countryName')) {
    app.$store.commit('setCountryName', context.countryName);
}

if (_.has(context, 'countrySlug')) {
    app.$store.commit('setCountrySlug', context.countrySlug);
}

if (_.has(context, 'cdnProductionUrl')) {
    app.$store.commit('setCdnProductionUrl', context.cdnProductionUrl);
}

if (_.has(context, 'userIsFromExplicitRegion')) {
    app.$store.commit('setUserIsFromExplicitRegion', context.userIsFromExplicitRegion);
}

if (_.has(context, 'hideExplicitRegionAds')) {
    app.$store.commit('setHideExplicitRegionAds', context.hideExplicitRegionAds);
}

if (_.has(context, 'showStoriesCookieSet')) {
    app.$store.commit('setShowStoriesCookieSet', context.showStoriesCookieSet);
}
